var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scheduling-buttons d-flex flex-column"},_vm._l((_vm.$options.tasks),function(ref){
var name = ref.name;
var label = ref.label;
return _c('v-btn',{key:name,staticClass:"mb-10",attrs:{"loading":_vm.pendingRequests[name],"color":_vm.buttonColor[name]},on:{"click":function($event){return _vm.onTaskInvokeClick(name)}}},[_vm._v(" "+_vm._s(label)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }